var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.15 219.15",
    style: {
      fill: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.57 219.15c60.42 0 109.57-49.16 109.57-109.58S169.99-.01 109.57-.01 0 49.16 0 109.57s49.16 109.58 109.57 109.58zm0-204.15c52.15 0 94.57 42.43 94.57 94.57 0 52.15-42.43 94.57-94.57 94.58-52.15 0-94.57-42.43-94.57-94.58S57.43 15 109.57 15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.86 156.51a7.502 7.502 0 1010.61-10.61l-28.82-28.82h83.46c4.14 0 7.5-3.37 7.5-7.51s-3.36-7.5-7.5-7.5H76.65l28.83-28.82a7.502 7.502 0 000-10.61c-1.46-1.46-3.38-2.2-5.3-2.2s-3.84.73-5.3 2.2l-41.63 41.63a7.485 7.485 0 00-2.2 5.3c0 1.99.79 3.9 2.2 5.31l41.63 41.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoWhite);
export default __webpack_public_path__ + "static/media/icon-go-white.1901df162a9f9a62dead2075f949e8e4.svg";
export { ForwardRef as ReactComponent };